import React, { useState, useEffect } from "react";
import Loading from "../components/Loading";
import Features from "../components/Features";
import logo from "../images/wizafy-logo.png";
import exploreImage from "../images/wizafy-explore.jpg";
import playlistImage from "../images/wizafy-playlists.jpg";
import generatorImage from "../images/wizafy-generator.jpg";
import Lottie from "react-lottie";
import animationData from "../images/lottie-notes.json";
import musicBlob from "../images/blob-sound-wave.json";
import musicWave from "../images/blue-waves.json";

import Scroll from "react-scroll-to-element";
import VideoPlayer from "../components/VideoPlayer";
import Footer from "../components/Footer";
import CTAButton from "../components/CTAButton";
const imageList = [
  { img: generatorImage, alt: "wizafy generator page" },
  { img: playlistImage, alt: "wizafy playlist page" },
  { img: exploreImage, alt: "wizafy explore page" },
];

const StartScreen = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [logoPaused, setLogoPaused] = useState(null);
  const [headerColor, setHeaderColor] = useState("white");
  const loginToSpoify = () => {
    setIsLoading(true);
    return (window.location = process.env.REACT_APP_SERVER_URL);
  };

  useEffect(() => {
    setLogoPaused(true);
  }, []);

  const noteOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  const blobOptions = {
    loop: true,
    autoplay: true,
    animationData: musicBlob,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  const waveOptions = {
    loop: true,
    autoplay: true,
    animationData: musicWave,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  const offset = window.innerWidth < 680 ? -200 : -100;
  return (
    <div className="start-screen">
      <header>
        <div className="container">
          <div className="header-content">
            <Scroll offset={0}>
              <div
                className="wizafy-logo-wrap"
                onMouseOver={() => setLogoPaused(false)}
                onMouseLeave={() => setLogoPaused(true)}
              >
                <div className="wizafy-logo">
                  <Lottie
                    options={blobOptions}
                    height={35}
                    isPaused={logoPaused}
                    speed={0.3}
                  />
                </div>
                <h1>Wizafy</h1>
              </div>
            </Scroll>

            <div className="links">
              <Scroll type="id" element="features" offset={offset}>
                <a>Features</a>
              </Scroll>
              <Scroll type="id" element="how-it-works" offset={offset}>
                <a>How it works</a>
              </Scroll>
              <Scroll type="id" element="footer" offset={offset}>
                <a>Developer</a>
              </Scroll>
            </div>
            <CTAButton
              fill={false}
              title="sign in with spotify"
              onClick={loginToSpoify}
              color="#5271ff"
              textColor="#5271ff"
              loading={isLoading}
            />
          </div>
        </div>
      </header>
      <section className="main">
        <div className="waves">
          <Lottie options={waveOptions} speed={0.1} />
        </div>
        <div className="container">
          <div className="above-fold">
            <div className="description">
              <div className="desc-wrap">
                <h2>
                  Create a Spotify Playlist with this easy to use playlist
                  generator.
                </h2>
                <div className="subtext">
                  <h3>
                    Wizafy can access all spotify <b>playlists</b>,{" "}
                    <b>albums</b> and <b>songs</b> with the browser or generate
                    a playlist of your own.
                  </h3>
                </div>
                <CTAButton
                  fill={true}
                  title="create playlist"
                  onClick={loginToSpoify}
                  color="#5271ff"
                  textColor="#fff"
                  loading={isLoading}
                />
              </div>
            </div>
            <div className="hero">
              <div className="circle"></div>
              <div className="circle2"></div>
              <div className="lottie-notes">
                <Lottie options={noteOptions} height={300} width={300} />
              </div>

              <figure className="stack stack-fanout">
                {imageList.map((item, i) => (
                  <img src={item.img} alt={item.alt} key={`key_${i}`} />
                ))}
              </figure>
            </div>
          </div>
        </div>
      </section>

      <div className="below-fold">
        <section id="features">
          <div className="container">
            <div className="description-section">
              <div className="desc-wrap">
                <h3>Checkout Wizafy's latest features.</h3>
                <div className="subtext">
                  <h4>
                    Wizafy has the best features of any spotify playlist
                    generator on the web, checkout the list below.
                  </h4>
                </div>
              </div>
            </div>
            <Features />
          </div>
        </section>
        <section id="how-it-works">
          <div className="video-section container">
            <div className="description-section">
              <div className="desc-wrap">
                <h3>How to use the Spotify playlist generator.</h3>
                <div className="subtext">
                  <h4>
                    Create a playlist from genres, songs or your top played
                    tracks, choose from 7 attributes to fine tune your
                    playlists.
                  </h4>
                </div>
              </div>
            </div>

            <div className="video-container">
              <VideoPlayer />
            </div>
          </div>
        </section>
        <footer id="footer">
          <Footer />
        </footer>

        {/* <footer >
         
          <CTAButton
              fill={true}
              title="Syntappz"
              onClick={openPortfolio}
              color="#fff"
              textColor="#021639"
            />
        

          <p className="copy">Wizafy &copy; 2021</p>
        </footer> */}
      </div>
    </div>
  );
};

export default StartScreen;
{
  /* <div className="background"></div>
<div className="top">
  <div className="wrap">
    <h1 style={{ color: "white" }}>welcome to wizafy</h1>
    <h3>sign in to spotify for wizardry</h3>
    <MdArrowDownward className="down-arrow" />
    <div
      onClick={loginToSpoify}
      className="btn"
      style={{ background: "white" }}
    >
      <MdPerson
        className="icon"
        style={{ fontSize: "22px", color: "#554fd8" }}
      />
      <p style={{ color: "#554fd8" }}>sign in</p>
    </div>
  </div>
</div>

<div className="bottom">{isLoading ? <Loading /> : <Features />}</div> */
}

const Gallery = () => {
  return <div class="gallery"></div>;
};
